import React from 'react'
import { ITag } from 'office-ui-fabric-react'
import {
  AssetTagsResponse,
  getITagsFromAssetTagsResponse,
} from '../../../../Api/campaigns'
import { TagInput } from '../../../../Components/Input/TagInput'

export function TargetedAssetsInput({
  targetedAssets,
  setTargetedAssets,
  assetTagsResponse,
  errorMessage,
  disabled,
}: {
  targetedAssets: string[]
  setTargetedAssets: (targetedAssets: string[]) => void
  assetTagsResponse: AssetTagsResponse
  errorMessage: string
  disabled: boolean
}) {
  const tags = getITagsFromAssetTagsResponse(assetTagsResponse)
  return (
    <TagInput
      label="Targeted Assets"
      errorMessage={errorMessage}
      required={true}
      disabled={disabled}
      pickerLabels={{
        noResults: 'Placement tags not found',
        suggestionsHeader: 'Placement tags',
      }}
      onResolveSuggestions={(filter, tagList): ITag[] => {
        const filterRank = (t: ITag) =>
          t.name.toLowerCase().indexOf(filter.toLowerCase())
        return tags
          .filter((t) => filterRank(t) !== -1)
          .filter((t) => !(tagList || []).find((t2) => t2.key === t.key))
          .sort((a, b) => filterRank(a) - filterRank(b))
      }}
      itemLimit={50}
      onChange={async (value?: ITag[]) => {
        setTargetedAssets((value || []).map((t) => t.key))
      }}
      selectedItems={
        targetedAssets
          .map((s) => tags.find((t) => t.key === s))
          .filter(Boolean) as ITag[]
      }
    />
  )
}
